const helixPara = {
    gap: -1,
    radius: 20,
    theta: 30,
    planeNum: 0,
    url: "assets/resource/project/",
    imagType: ".png"
}

export default helixPara;